import { create } from "zustand";
import { filter } from "interface";
import { specsManagementFilter } from "../type";

type specsListStore = {
  isEdit: boolean;
  formData?: any;
  setIsEdit: (val: boolean) => void;
  setFormData: (formData?: any) => void;
  filter?: filter<specsManagementFilter>[];
  setFilter: (filter: filter<specsManagementFilter>[]) => void;
  page: number;
  setPage: (value: number) => void;
};

export const useSpecsListStore = create<specsListStore>((set) => {
  return {
    page: 1,
    isEdit: false,
    filter: [],
    setFormData: (value: any | undefined) => {
      set({ formData: value });
    },
    setIsEdit: (value: boolean) => {
      set({ isEdit: value });
    },
    setFilter: (value: filter<specsManagementFilter>[]) => {
      set({ page: 1, filter: value });
    },
    setPage: (value: number) => {
      set({ page: value });
    },
  };
});
